var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { defineMessages, injectIntl } from 'react-intl';
import { toggleSidebar as toggleSidebarAction } from '../../actions/creators/sidebar';
var messages = defineMessages({
    information: {
        id: 'sidebar.information',
        defaultMessage: 'Информация'
    },
    results: {
        id: 'sidebar.information.results',
        defaultMessage: 'Информация'
    },
    termsAndConditions: {
        id: 'sidebar.information.termsAndConditions',
        defaultMessage: 'Правила'
    },
    contacts: {
        id: 'sidebar.information.contacts',
        defaultMessage: 'Контакты'
    },
    bonusesAndPromotions: {
        id: 'sidebar.information.bonusesAndPromotions',
        defaultMessage: 'Акции и бонусы'
    },
    kycPolicy: {
        id: 'sidebar.information.kycPolicy',
        defaultMessage: 'Политика KYC'
    },
    news: {
        id: 'news.title',
        defaultMessage: 'Новости'
    },
    partners: {
        id: 'partners.title',
        defaultMessage: 'Партнерская программа'
    }
});
var Info = /** @class */ (function (_super) {
    __extends(Info, _super);
    function Info() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.toggleSidebar = function () {
            _this.props.toggleSidebarAction(_this.props.sidebarToggled);
        };
        _this.hideSidebar = function () {
            _this.props.sidebarToggled === false || _this.toggleSidebar();
        };
        return _this;
    }
    Info.prototype.render = function () {
        return (_jsx("li", { children: _jsxs("div", __assign({ className: 'forms' }, { children: [_jsx(Link, __assign({ to: '/results', onClick: this.hideSidebar }, { children: this.props.intl.formatMessage(messages.results) })), _jsx(Link, __assign({ to: '/terms_and_conditions', onClick: this.hideSidebar }, { children: this.props.intl.formatMessage(messages.termsAndConditions) })), (_jsx(Link, __assign({ to: '/bonus', onClick: this.hideSidebar }, { children: this.props.intl.formatMessage(messages.bonusesAndPromotions) }))), _jsx(Link, __assign({ to: '/kyc_policy', onClick: this.hideSidebar }, { children: this.props.intl.formatMessage(messages.kycPolicy) }))] })) }));
    };
    return Info;
}(React.Component));
var mapStateToProps = function (state) { return ({
    sidebarToggled: state.application.get('sidebarToggled'),
    country: state.application.get('client').country,
}); };
var mapDispatchToProps = function (dispatch) { return bindActionCreators({
    toggleSidebarAction: toggleSidebarAction
}, dispatch); };
Info = connect(mapStateToProps, mapDispatchToProps)(Info);
export default injectIntl(Info);



// WEBPACK FOOTER //
// ./src/components/sidebar/Info.jsx